import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@eureca/ui';

/**
 * EU-709 RN-21/RN-22 — o `Salvar` de `Remuneração` numa vaga Banco de talentos.
 *
 * Nenhum campo da seção é obrigatório nesse tipo, então o botão nunca pode ser
 * bloqueado por "campo obrigatório". O que o bloqueia é não haver NADA a
 * salvar: com o formulário inteiramente vazio o `Salvar` fica inativo, o hover
 * explica o porquê e o cursor assume o símbolo de bloqueado. Para sair sem
 * salvar, o consultor usa o `Voltar`.
 *
 * Irmão do `BlockedEditTooltip` (EU-569), com mensagem própria: aquele diz que
 * a edição está proibida; este diz que ainda não há o que gravar.
 */
export const EMPTY_SAVE_TOOLTIP = 'Preencha algum campo para salvar';

export function EmptySaveTooltip({ enabled, children }: { enabled: boolean; children: ReactNode }) {
  if (!enabled) return <>{children}</>;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* O botão desabilitado não dispara mouse events em todos os
              engines, então o hover precisa chegar no wrapper. */}
          <div
            className="cursor-not-allowed [&>*]:pointer-events-none"
            data-testid="job-compensation-save-blocked"
          >
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent side="top">{EMPTY_SAVE_TOOLTIP}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
